import script from "./clamatoView.vue?vue&type=script&setup=true&lang=js"
export * from "./clamatoView.vue?vue&type=script&setup=true&lang=js"

import "./clamatoView.vue?vue&type=style&index=0&id=04da3d7a&lang=css"

const __exports__ = script;

export default __exports__